class $a5fd07fa01589658$export$2e2bcd8739ae039 {
    constructor(initialState){
        this.size = 4;
        this.board = initialState ? this.clone(initialState) : this.createEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    createEmptyBoard() {
        return Array.from({
            length: this.size
        }, ()=>Array(this.size).fill(0));
    }
    clone(board) {
        return board.map((row)=>[
                ...row
            ]);
    }
    getState() {
        return this.clone(this.board);
    }
    getScore() {
        return this.score;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.status = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    restart() {
        this.board = this.createEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    addRandomTile() {
        const empty = [];
        for(let row = 0; row < this.size; row++){
            for(let col = 0; col < this.size; col++)if (this.board[row][col] === 0) empty.push([
                row,
                col
            ]);
        }
        if (empty.length === 0) return;
        const [i, j] = empty[Math.floor(Math.random() * empty.length)];
        this.board[i][j] = Math.random() < 0.9 ? 2 : 4;
    }
    moveLeft() {
        return this.move((row)=>row);
    }
    moveRight() {
        return this.move((row)=>[
                ...row
            ].reverse());
    }
    moveUp() {
        this.transpose();
        const moved = this.move((row)=>row);
        this.transpose();
        return moved;
    }
    moveDown() {
        this.transpose();
        const moved = this.move((row)=>[
                ...row
            ].reverse());
        this.transpose();
        return moved;
    }
    move(transform) {
        if (this.status !== "playing") return false;
        let moved = false;
        for(let i = 0; i < this.size; i += 1){
            const originalRow = this.board[i];
            const row = transform([
                ...originalRow
            ]);
            const compressed = row.filter((value)=>value !== 0);
            for(let j = 0; j < compressed.length - 1; j += 1)if (compressed[j] === compressed[j + 1]) {
                compressed[j] *= 2;
                this.score += compressed[j];
                compressed[j + 1] = 0;
            }
            const newRow = compressed.filter((value)=>value !== 0);
            while(newRow.length < this.size)newRow.push(0);
            const finalRow = transform(newRow);
            if (finalRow.some((value, index)=>value !== originalRow[index])) moved = true;
            this.board[i] = finalRow;
        }
        if (moved) {
            this.addRandomTile();
            this.updateStatus();
        }
        return moved;
    }
    transpose() {
        this.board = this.board[0].map((_, i)=>this.board.map((row)=>row[i]));
    }
    updateStatus() {
        if (this.board.flat().includes(2048)) {
            this.status = "win";
            return;
        }
        if (this.canMove()) return;
        this.status = "lose";
    }
    canMove() {
        for(let i = 0; i < this.size; i += 1)for(let j = 0; j < this.size; j += 1){
            if (this.board[i][j] === 0) return true;
            if (j < this.size - 1 && this.board[i][j] === this.board[i][j + 1]) return true;
            if (i < this.size - 1 && this.board[i][j] === this.board[i + 1][j]) return true;
        }
        return false;
    }
}


const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$cells = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$scoreEl = document.querySelector(".game-score");
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$msgStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$msgWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$msgLose = document.querySelector(".message-lose");
function $09e991522ca7e64e$var$render() {
    const state = $09e991522ca7e64e$var$game.getState().flat();
    $09e991522ca7e64e$var$cells.forEach((cell, i)=>{
        const value = state[i];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value) cell.classList.add(`field-cell--${value}`);
    });
    $09e991522ca7e64e$var$scoreEl.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$updateMessages();
}
function $09e991522ca7e64e$var$updateMessages() {
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    $09e991522ca7e64e$var$msgStart.classList.add("hidden");
    $09e991522ca7e64e$var$msgWin.classList.add("hidden");
    $09e991522ca7e64e$var$msgLose.classList.add("hidden");
    if (gameStatus === "idle") $09e991522ca7e64e$var$msgStart.classList.remove("hidden");
    if (gameStatus === "win") $09e991522ca7e64e$var$msgWin.classList.remove("hidden");
    if (gameStatus === "lose") $09e991522ca7e64e$var$msgLose.classList.remove("hidden");
}
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$button.textContent = "Restart";
        $09e991522ca7e64e$var$button.classList.remove("start");
        $09e991522ca7e64e$var$button.classList.add("restart");
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$button.textContent = "Start";
        $09e991522ca7e64e$var$button.classList.remove("restart");
        $09e991522ca7e64e$var$button.classList.add("start");
    }
    $09e991522ca7e64e$var$render();
});
document.addEventListener("keydown", (e)=>{
    let moved = false;
    switch(e.key){
        case "ArrowLeft":
            moved = $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $09e991522ca7e64e$var$game.moveDown();
            break;
    }
    if (moved) $09e991522ca7e64e$var$render();
});
$09e991522ca7e64e$var$render();


//# sourceMappingURL=index.bb0eec71.js.map
